import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './App.css';
import FrontPage from './pages/FrontPage.js';
import RoomPage from './pages/RoomPage.js';
import GalleryPage from './pages/GalleryPage.js';
import ConnectionToast from './components/common/ConnectionToast.js';

function App() {
    return (
        <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
            <Routes>
                <Route path="/" element={<FrontPage />} />
                <Route path="/room/:roomId" element={<RoomPage />} />
                <Route path="/gallery/:id" element={<GalleryPage />} />
            </Routes>
            <ConnectionToast />
        </BrowserRouter>
    );
}

export default App;
